import * as React from 'react'

import { Accept, useDropzone } from 'react-dropzone'
import { convertImage, convertJPGType } from '@components/imagePicker/utils'

interface FileUpload {
  filename: string
  mimeType: string
  data: string
}

interface Props {
  children: React.ReactNode
  onFileUploaded: (files: FileUpload[]) => void
  types?: Accept
  allowAllTypes?: boolean
}

interface Data extends Blob {
  name: string
}

const IMAGE_FILE_TYPES = { 'image/jpeg': ['.jpg', '.jpeg'], 'image/png': ['.png'] }
const FILE_TYPES = { 'application/pdf': ['.pdf'], ...IMAGE_FILE_TYPES }

const FilePicker = ({ children, onFileUploaded, types, allowAllTypes }: Props) => {
  const readFile = (file: Data) => {
    return new Promise<FileUpload>((resolve, reject) => {
      const reader = new FileReader()
      reader.onload = () => {
        const filename = file.name.split('/').pop() || file.name
        const fileType = convertJPGType(file.type) || '*/*'

        if (Object.keys(IMAGE_FILE_TYPES).includes(fileType) && !types) {
          convertImage(reader.result as string, fileType).then((data) =>
            resolve({ data, filename, mimeType: fileType })
          )
        } else {
          resolve({ data: reader.result as string, filename, mimeType: fileType })
        }
      }
      reader.onerror = () => reject('error')
      reader.onabort = () => reject('canceled')

      reader.readAsDataURL(file)
    })
  }

  const onDrop = (files: Data[]) => {
    Promise.all(files.map(readFile)).then(onFileUploaded)
  }

  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    accept: !allowAllTypes ? types || FILE_TYPES : undefined,
  })

  return (
    <div {...getRootProps()} style={{ cursor: 'pointer' }}>
      <input {...getInputProps()} />
      {children}
    </div>
  )
}

export default FilePicker
